import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import Layout from "./components/site/Layout";
import { servicePages } from "./content/siteContent";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import HomePage from "./pages/HomePage";
import LocalSeoPage from "./pages/LocalSeoPage";
import ServiceDetailPage from "./pages/ServiceDetailPage";
import ServicesPage from "./pages/ServicesPage";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
};

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/servicos" element={<ServicesPage />} />
          <Route
            path={servicePages.cabinePrimaria.path}
            element={<ServiceDetailPage service={servicePages.cabinePrimaria} />}
          />
          <Route
            path={servicePages.ensaiosEletricos.path}
            element={<ServiceDetailPage service={servicePages.ensaiosEletricos} />}
          />
          <Route
            path={servicePages.comissionamentoPaineis.path}
            element={<ServiceDetailPage service={servicePages.comissionamentoPaineis} />}
          />
          <Route
            path="/manutencao-eletrica-industrial-sp"
            element={<LocalSeoPage />}
          />
          <Route path="/sobre" element={<AboutPage />} />
          <Route path="/contato" element={<ContactPage />} />
          <Route path="*" element={<Navigate replace to="/" />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
